module.exports = __webpack_public_path__ + "img/UMUC.36e29299.svg";